import styled from 'styled-components';

import { space, media } from '../../ui/helpers';
import { colors } from '../../ui/design-tokens';

const Container = styled.ul`
  align-items: center;
  display: inline-flex;

  .item:not(:last-child) {
    margin: 0 ${space()} 0 0;
  }

  .title {
    color: ${colors.neutral[400]};
  }

  .icon {
    align-items: center;
    border-radius: 50%;
    display: inline-flex;
    height: ${space(5)};
    justify-content: center;
    width: ${space(5)};

    &.facebook {
      background: #1877f2;
    }
    &.instagram {
      background: #e4405f;
    }
    &.twitter {
      background: #1da1f2;
    }
    &.linkedin {
      background: #0a66c2;
    }
    &.youtube {
      background: #ff0000;
    }
    &.spotify {
      background: #1ed760;
    }

    svg {
      height: ${space(2)};
      width: ${space(2)};
    }
  }

  li:last-child .icon {
    margin-right: 0;
  }

  ${media.min('medium')`
    padding-right: ${space(3)};
    .icon {
      height: ${space(4)};
      width: ${space(4)};
    }
  `};
`;

export { Container };
